<template>
	<Layout class="main">
		<Header
			:style="{background: '#fff', boxShadow: '0 2px 3px 2px rgba(0,0,0,.1)'}">
			<header-bar class="header-con">
				<user :message-unread-count="1" :user-avator="$store.state.user.head_img" :user-name="$store.state.user.nick"/>
				<!--<fullscreen v-model="isFullscreen" style="margin-right: 10px;" />-->
			</header-bar>
		</Header>
		<Content class="content-wrapper">
			<keep-alive v-if="isRouterAlive">
				<router-view/>
			</keep-alive>
		</Content>
	</Layout>
</template>
<script>
	import User from './components/user'
	import HeaderBar from './components/header-bar'
	// import Fullscreen from "./components/fullscreen";
	import "./main.less";
	import {mapActions} from "vuex";

	export default {
		name: 'Main',
		components: {
			User,
			HeaderBar,
			// Fullscreen
		},
		provide() {
			return {
				reloadContent: this.reloadContent
			}
		},
		data() {
			return {
				isRouterAlive: true,
				isFullscreen: false,
			}
		},
		computed: {},
		methods: {
			...mapActions(["queryOperationList", "getdiffPackStatis"]),
			reloadContent() {
				this.isRouterAlive = false;
				this.$nextTick(function () {
					this.isRouterAlive = true
				})
			},
			click() {
				this.$router.push({name: "sortingSorting",});
			}
		},
		watch: {},
		created() {
			// 初始化长连接
			this.getdiffPackStatis(this);
			this.queryOperationList();
		}
	}
</script>

<style scoped>
	.leftCollapsed {
		left: 60px;
		width: calc(100% - 60px);

	}

	.leftNormal {
		left: 68px;
		width: calc(100% - 68px);
	}

	.myslide .ivu-dropdown {
		min-height: 50px;
	}

	.myHeader {
		top: 0;
		z-index: 100;
		height: 62px;
		position: fixed;
		background: #FFFFFF;
		box-shadow: 0 0 2px rgba(0, 0, 0, 0.1);
	}

	.mySlideReal::-webkit-scrollbar {
		display: none;
	}

	.ivu-layout-sider-children::-webkit-scrollbar {
		display: none;
	}

	.header-con {
		background: #fff;
		padding: 0;
		width: 100%;
	}

	#leftSideBox .ivu-layout-sider-children {
		background-color: red;
	}

	#leftSideBox .ivu-layout-sider-children::-webkit-scrollbar {
		display: none;
	}
</style>



// WEBPACK FOOTER //
// src/components/main/main.vue